<template>
  <div >
    <el-menu  style="height:50px;background-color:white" class="navbar fac" mode="horizontal">
      <hamburger
        class="hamburger-container"
        :toggleClick="toggleSideBar"
        :isActive="sidebar.opened"
      ></hamburger>
      <breadcrumb></breadcrumb>
     
      <el-dropdown class="avatar-container" trigger="click">
        <div class="avatar-wrapper">
          <!-- <img class="user-avatar" :src="logo" /> -->
          {{text}}
          <i class="el-icon-caret-bottom"></i>
        </div>
        <el-dropdown-menu class="user-dropdown" slot="dropdown">
          <el-dropdown-item divided>
            <span @click="handlerPass" style="display:block;">修改密码</span>
          </el-dropdown-item>
          <router-link class="inlineBlock" to="/"><el-dropdown-item>首页</el-dropdown-item></router-link>
          <el-dropdown-item divided>
            <span @click="logout" style="display:block;">退出</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </el-menu>
    <el-dialog title="修改我的密码" :visible.sync="dialogVisible" width="40%" @close="close">
      <el-form :model="admin" ref="adminForm" label-width="150px" size="small" :rules="loginRules">
        <el-form-item label="用户名：" prop="username" >
          <el-input v-model="admin.username" style="width: 250px" disabled></el-input>
        </el-form-item>
        <el-form-item label="旧密码：" prop="oldPassword">
          <el-input
            name="password"
            :type="pwdType"
            v-model="admin.oldPassword"
            autoComplete="on"
            placeholder="请输入旧密码"
            style="width: 250px"
          >
            <span slot="suffix" @click="showPwd">
              <svg-icon icon-class="eye" class="color-main"></svg-icon>
            </span>
          </el-input>
        </el-form-item>
        <el-form-item label="新密码：" prop="newPassword">
          <el-input
            name="password"
            :type="pwdType"
            v-model="admin.newPassword"
            autoComplete="on"
            placeholder="请输入新密码："
            style="width: 250px"
          >
            <span slot="suffix" @click="showPwd">
              <svg-icon icon-class="eye" class="color-main"></svg-icon>
            </span>
          </el-input>
        </el-form-item>
        <el-form-item label="确认密码：" prop="isPassword">
          <el-input
            name="password"
            :type="pwdType"
            v-model="isPassword"
            autoComplete="on"
            placeholder="请输入确认密码"
            style="width: 250px"
          >
            <span slot="suffix" @click="showPwd">
              <svg-icon icon-class="eye" class="color-main"></svg-icon>
            </span>
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="handleDialogConfirm('adminForm')" size="small">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Breadcrumb from '@/components/Breadcrumb';
import Hamburger from '@/components/Hamburger';
import logo from '@/assets/images/logo.jpg';
import { updatePassword , adminInfo } from '@/api/login';

const defaultAdmin = {
  username: null,
  newPassword: null,
  oldPassword: null
};
export default {
  components: {
    Breadcrumb,
    Hamburger
  },
  computed: {
    ...mapGetters(['sidebar', 'avatar'])
  },
  created(){
       let { username } = JSON.parse(localStorage.getItem("userInfo"));
       if(username){
        this.admin.username = username
       }
       this.getAdminInfo()
  },
  data() {
    const validatePass = (rule, value, callback) => {
      if (value.length < 3) {
        callback(new Error('密码不能小于3位'));
      } else {
        callback();
      }
    };
    return {
      logo,
      dialogVisible: false,
      admin: Object.assign({}, defaultAdmin),
      pwdType: 'password',
      isPassword: '',
      text:'',
      loginRules: {
        username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        oldPassword: [{ required: true, message: '请输入新密码', trigger: 'blur' }],
        newPassword: [{ required: true, message: '请输入旧密码', trigger: 'blur' }]
      }
    };
  },
  methods: {
    showPwd() {
      if (this.pwdType === 'password') {
        this.pwdType = '';
      } else {
        this.pwdType = 'password';
      }
    },
    handleDialogConfirm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$confirm('是否确认修改密码?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            if (this.admin.newPassword != this.isPassword) {
              this.$message({
                message: '新密码与确认密码不一致',
                type: 'warning'
              });
            }
            updatePassword(this.admin).then(res => {
              if (res.code == '502') {
                this.$message({
                  message: res.message,
                  type: 'warning'
                });
              } else if (res.code == '200') {
                this.dialogVisible = false;
                this.logout();
                this.$message({
                  message: '修改成功！',
                  type: 'success'
                });
              }
            });
          });
        } else {
          this.$message({
            message: '请完善信息',
            type: 'warning'
          });
          return false;
        }
      });
    },


    async getAdminInfo(){
      try {
        let { data  , code }  = await adminInfo()
        console.log( data  , code );
        if(code == 200){
          this.text = `(${data.teamName}) ${data.roleName} - ${data.nickName}`
        }
        
      } catch (error) {
        this.text = '暂无数据'
      }
    },

    close() {
       this.admin = {};
       let { username } = JSON.parse(localStorage.getItem("userInfo"));
       if(username){
        this.admin.username = username
       }
    },
    handlerPass() {
      this.dialogVisible = true;
    },
    toggleSideBar() {
      this.$store.dispatch('ToggleSideBar');
    },
    logout() {
      this.$store.dispatch('LogOut').then(() => {
        location.reload(); // 为了重新实例化vue-router对象 避免bug
      });
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 50px;
  line-height: 50px;
  border-radius: 0px !important;
  background-color: #2B2D39;
  overflow: hidden;
  .hamburger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 10px;
  }

  .screenfull {
    position: absolute;
    right: 90px;
    top: 16px;
    color: red;
  }

  .avatar-container {
    height: 50px;
    display: inline-block;
    position: absolute;
    right: 35px;

    .avatar-wrapper {
      cursor: pointer;
      margin-top: 5px;
      position: relative;

      .user-avatar {
        width: 40px;
        height: 40px;
        border-radius: 10px;
      }

      .el-icon-caret-bottom {
        position: absolute;
        right: -20px;
        top: 18px;
        font-size: 12px;
      }
    }
  }
}
.fac{
  display: flex;
  align-items: center;
}
.breadcrumb_c{
  background-color: #000;
  width: 140px;
  height: 100px;
  color: white;
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #EFF0F2;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue